import { Injectable } from '@angular/core';
import {
  RouterCancelAction,
  ROUTER_CANCEL
} from '@ngrx/router-store';
import {
  Effect,
  ofType,
  Actions
} from '@ngrx/effects';
import {
  map,
  filter
} from 'rxjs/operators';
import { AppNavigateTo } from './life-cycle/life-cycle.actions';

@Injectable()
export class CoreEffects {

  @Effect()
  public navigationError$ = this.actions$.pipe(
    ofType<RouterCancelAction<any>>(ROUTER_CANCEL),
    filter(action => !!action.payload.event.reason.match(/Navigation ID [0-9]+ is not equal to the current navigation id [0-9]+/)),
    map(action => new AppNavigateTo([action.payload.event.url], 'navigationError$'))
  );

  constructor(
    public actions$: Actions,
  ) {}

}
